import styled from '@emotion/styled';
import { Input } from '../Input';

export const OptionContainer = styled.div`
  text-align: left;
`;

export const OptionWrapper = styled.div<{
  index: number;
  hasIconLeft: boolean;
  hasIconRight: boolean;
}>`
  background: ${(props) =>
    props.index % 2 === 0 ? props.theme.color.light.tint : props.theme.color.light.default};
  color: ${(props) => props.theme.color.dark.default};

  width: 100%;
  padding: 9px 20px;
  ${(props) =>
    props.hasIconLeft &&
    `
    padding-left: 50px; // 20 + 24 + 6 
  `}
  ${(props) =>
    props.hasIconRight &&
    `
    padding-right: 50px; // 20 + 24 + 6 
  `}
  position: relative;
  &:hover {
    /* color: ${(props) => props.theme.color.blue.default}; */
    background: ${(props) => props.theme.color.light.shadeLighter};
    /* font-weight: 600; */
  }
`;

export const OptionLabel = styled.div`
  font-size: 16px;
  /* line-height: 32px; */
  cursor: pointer;
  & .highlighter {
    background: ${(props) => props.theme.color.yellow.default};
  }
`;

export const IconWrapper = styled.div<{ position: 'right' | 'left' }>`
  font-size: 16px;
  width: 24px;
  height: 24px;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  ${(props) => props.position === 'right' && 'right: 12px;'}
  ${(props) => props.position === 'left' && 'left: 12px;'}
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const StyledInput = styled(Input)`
  border: none;
  border-bottom: 2px solid ${(props) => props.theme.color.light.shade};
  border-radius: 0;
`;
